<template>
  <div>
    <v-dialog
      ref="tasksDialog"
      v-model="tasksDialog"
      fullscreen
    >
      <v-card>
        <v-card-title>
          <v-toolbar
            card
            dark
            color="primary"
          >
            <v-btn
              icon
              @click="closeTasks()"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Расписание снятия показаний</v-toolbar-title>
          </v-toolbar>
          <v-dialog
            v-model="taskDialog"
            max-width="500px"
          >
            <v-btn
              slot="activator"
              color="primary"
              dark
              class="mb-2"
            >
              Добавить
            </v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">{{ taskDialogTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex
                      xs12
                      sm12
                      md12
                    >
                      <v-layout>
                        <v-flex
                          xs6
                          sm6
                          md6
                        >
                          <span v-if="editedTaskItem.interval == 'ONCE'">
                            <v-menu
                              ref="taskOnceDateValue"
                              v-model="taskOnceDateValue"
                              lazy
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              :nudge-right="40"
                              min-width="290px"
                              :return-value.sync="editedTaskItem.value"
                            >
                              <v-text-field
                                slot="activator"
                                v-model="editedTaskItem.value"
                                label="Дата выполнения"
                                prepend-icon="event"
                                readonly
                                required
                              />
                              <v-date-picker
                                v-model="editedTaskItem.value"
                                no-title
                                scrollable
                              >
                                <v-spacer />
                                <v-btn
                                  flat
                                  color="primary"
                                  @click="taskOnceDateValue = false"
                                >Отмена</v-btn>
                                <v-btn
                                  flat
                                  color="primary"
                                  @click="$refs.taskOnceDateValue.save(editedTaskItem.value)"
                                >OK</v-btn>
                              </v-date-picker>
                            </v-menu>
                          </span>
                          <span v-else>
                            <v-text-field
                              v-model="editedTaskItem.value"
                              mask="#######"
                              label="Каждые"
                              required
                            />
                          </span>
                        </v-flex>
                        <v-flex
                          xs6
                          sm6
                          md6
                        >
                          <v-autocomplete
                            v-model="editedTaskItem.interval"
                            :items="frequencies"
                            label=""
                            item-text="name"
                            item-value="id"
                            :menu-props="{maxHeight:'auto'}"
                            required
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <!--<v-flex xs12 sm12 md12>-->
                    <!--<v-menu-->
                    <!--ref="startTaskDate"-->
                    <!--lazy-->
                    <!--:close-on-content-click="false"-->
                    <!--v-model="startTaskDate"-->
                    <!--transition="scale-transition"-->
                    <!--offset-y-->
                    <!--full-width-->
                    <!--:nudge-right="40"-->
                    <!--min-width="290px"-->
                    <!--:return-value.sync="editedTaskItem.start_date"-->
                    <!--&gt;-->
                    <!--<v-text-field-->
                    <!--slot="activator"-->
                    <!--label="Дата и время начала выполнения"-->
                    <!--v-model="editedTaskItem.start_date"-->
                    <!--prepend-icon="event"-->
                    <!--readonly-->
                    <!--&gt;</v-text-field>-->
                    <!--<v-date-picker v-model="editedTaskItem.start_date" no-title scrollable>-->
                    <!--<v-spacer></v-spacer>-->
                    <!--<v-btn flat color="primary" @click="startTaskDate = false">Отмена-->
                    <!--</v-btn>-->
                    <!--<v-btn flat color="primary"-->
                    <!--@click="$refs.startTaskDate.save(editedTaskItem.start_date)">-->
                    <!--OK-->
                    <!--</v-btn>-->
                    <!--</v-date-picker>-->
                    <!--</v-menu>-->
                    <!--</v-flex>-->
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="saveCounterTask()"
                >
                  Сохранить
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="closeTasksDialog()"
                >
                  Отмена
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-title>
        <v-card-text>
          <v-card flat>
            <v-card-text>
              <v-data-table
                :headers="counterTasksHeaders"
                :items="counterTasks"
                :loading="tasksLoading"
                hide-actions
              >
                <template
                  slot="items"
                  slot-scope="props"
                >
                  <td>{{ props.item.interval }}</td>
                  <td>{{ props.item.value }}</td>
                  <!--<td>{{ props.item.start_date }}</td>-->
                  <td>
                    <span v-if="props.item.enabled">
                      <v-btn
                        icon
                        class="mx-0"
                        @click="stopTasks(props.item)"
                      >
                        <v-icon color="teal">stop</v-icon>
                      </v-btn>
                    </span>
                    <span v-else>
                      <v-btn
                        icon
                        class="mx-0"
                        @click="startTasks(props.item)"
                      >
                        <v-icon color="teal">play_arrow</v-icon>
                      </v-btn>
                    </span>
                  </td>
                  <td class="justify-center layout px-0">
                    <v-btn
                      icon
                      class="mx-0"
                      @click="editCounterTask(props.item)"
                    >
                      <v-icon color="teal">
                        edit
                      </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      class="mx-0"
                      @click="deleteCounterTask(props.item)"
                    >
                      <v-icon color="teal">
                        delete
                      </v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-tabs
      slot="extension"
      v-model="tab"
      align-with-title
    >
      <v-tabs-slider color="yellow" />
      <v-tab :key="0">
        Данные
      </v-tab>
      <v-tab :key="1">
        Сбор данных
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item :key="0">
        <v-card flat>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex
                  xs4
                  sm4
                  md4
                >
                  <v-select
                    v-model="parameter_id"
                    :items="available_params"
                    label="Параметр счетчика"
                    item-text="name"
                    item-value="id"
                  />
                </v-flex>
                <v-flex
                  xs4
                  sm4
                  md4
                >
                  <v-select
                    v-model="reportInterval"
                    :items="reportIntervals"
                    label="Интервал"
                    item-text="name"
                    item-value="interval"
                    :menu-props="{maxHeight:'auto'}"
                    required
                  />
                </v-flex>
                <v-flex
                  xs4
                  sm4
                  md4
                >
                  <v-btn @click="requestData()">
                    Сформировать
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
            <v-tabs
              slot="extension"
              v-model="charsTab"
              align-with-title
            >
              <v-tabs-slider color="yellow" />
              <v-tab :key="0">
                График
              </v-tab>
              <v-tab :key="1">
                Таблица
              </v-tab>
              <v-tab :key="2">
                Показания счетчиков
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="charsTab">
              <v-tab-item :key="0">
                <line-chart
                  v-if="loaded"
                  :chart-data="countersData"
                  :chart-labels="labels"
                />
              </v-tab-item>
              <v-tab-item :key="1">
                <v-data-table
                  :headers="countersDataHeaders"
                  :items="countersData2"
                  :loading="countersDataLoading"
                  class="elevation-1"
                  hide-actions
                >
                  <template
                    slot="items"
                    slot-scope="props"
                  >
                    <td>{{ props.item.label }}</td>
                    <td>{{ props.item.value }}</td>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item :key="2">
                <v-flex
                  xs4
                  sm4
                  md4
                >
                  <v-select
                    v-model="accumulatedDataParam"
                    :items="accumulatedDataParams"
                    label="Варианты предоставления информации по накопленной энергии"
                    item-text="name"
                    item-value="id"
                    :menu-props="{maxHeight:'auto'}"
                    required
                  />
                </v-flex>
                <v-data-table
                  :headers="countersDataHeaders"
                  :items="countersAccumulatedData"
                  :loading="countersAccumulatedDataLoading"
                  class="elevation-1"
                  hide-actions
                >
                  <template
                    slot="items"
                    slot-scope="props"
                  >
                    <td>{{ props.item.label }}</td>
                    <td>{{ props.item.value }}</td>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="1">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="countersHeaders"
              :items="counters"
              :loading="countersLoading"
              class="elevation-1"
              hide-actions
            >
              <template
                slot="items"
                slot-scope="props"
              >
                <td>{{ props.item.serial_num }}</td>
                <td>{{ props.item.model.name }}</td>
                <td class="justify-center layout px-0">
                  <v-btn
                    icon
                    class="mx-0"
                    @click="openTasks(props.item)"
                  >
                    <v-icon color="teal">
                      date_range
                    </v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import LineChart from '../../shared-components/LineChart'
import axios from 'axios'

export default {
  name: 'PointCounterData',
  components: {
    LineChart
  },
  data () {
    return {
      point_id: this.$route.params['id'],
      tab: null,
      charsTab: null,
      counters: [],
      countersHeaders: [
        {
          text: 'Серийный номер',
          align: 'left',
          sortable: true,
          value: 'serial_num'
        },
        {
          text: 'Модель',
          align: 'left',
          value: 'model'
        },
        { text: '', value: '' }
      ],
      tasksDialog: false,
      tasksLoading: false,
      countersDataLoading: false,
      selectedCounterId: '',
      counterTasks: [],
      countersLoading: false,
      countersAccumulatedDataLoading: false,
      countersDataHeaders: [
        {
          text: 'Дата и время',
          align: 'left',
          sortable: false,
          value: 'label'
        },
        { text: 'Значение', value: 'value', sortable: false }
      ],
      counterTasksHeaders: [
        {
          text: 'Частота выполнения',
          align: 'left',
          sortable: false,
          value: 'serial_num'
        },
        { text: '', value: 'value', sortable: false },
        // { text: 'Дата и время начала', value: 'start_date' },
        { text: 'Выполняется', value: 'enabled' },
        { text: 'Действия', value: 'actions' }
      ],
      taskDialog: false,
      editedTaskIndex: -1,
      frequencies: [
        { id: 'minutes', name: 'Минут' },
        { id: 'hours', name: 'Часов' },
        { id: 'days', name: 'Дней' }
        // { id: 'WEEK', name: 'Недель' },
        // { id: 'MONTH', name: 'Месяцев' },
        // { id: 'ONCE', name: 'Единожды' }
      ],
      editedTaskItem: { counter_id: '' },
      editedCounterTaskIndex: -1,
      taskOnceDateValue: false,
      startTaskDate: false,
      loaded: false,
      countersData: [],
      countersData2: [],
      countersAccumulatedData: [],
      labels: [],
      available_params: [],
      parameter_id: '',
      reportIntervals: [
        { interval: '30', name: 'Полчаса' },
        { interval: '60', name: 'Час' },
        { interval: '1440', name: 'День' },
        { interval: '43200', name: 'Месяц' },
        { interval: '525600', name: 'Год' }
      ],
      accumulatedDataParams: [
        { id: '0', name: 'На начало текущих суток' },
        { id: '10030', name: '0:30 - для примера' }
      ],
      accumulatedDataParam: '',
      reportInterval: '30'
    }
  },
  computed: {
    taskDialogTitle () {
      return this.editedTaskIndex === -1 ? 'Новое задание' : 'Редактирование задания'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  mounted () {
    this.getPointCountersApi()
    this.getAvailableParams()
  },
  methods: {
    getPointCountersApi () {
      this.countersLoading = true
      axios.get(`/api/counters/?point_id=${this.point_id}`)
        .then((response) => {
          this.counters = response.data
          this.countersLoading = false
        })
        .catch((err) => {
          this.countersLoading = false
          console.log(err)
        })
    },
    getCounterTasksApi () {
      this.tasksLoading = true
      axios.get(`/api/counters_tasks/?counter_id=${this.selectedCounterId}`)
        .then((response) => {
          this.counterTasks = response.data
          this.tasksLoading = false
        })
        .catch((err) => {
          this.tasksLoading = false
          console.log(err)
        })
    },
    getAvailableParams () {
      axios.get(`/api/counters_data/available_params/?point_id=${this.point_id}`)
        .then(response => {
          this.available_params = response.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    openTasks (item) {
      this.selectedCounterId = item.counter_id
      this.getCounterTasksApi()
      this.tasksDialog = true
    },
    closeTasks () {
      this.tasksDialog = false
    },
    addTaskApi () {
      this.tasksLoading = true
      this.editedTaskItem.counter_id = this.selectedCounterId
      axios.post(`/api/counters_tasks/`, this.editedTaskItem)
        .then((response) => {
          this.tasksLoading = false
          this.counterTasks.push(response.data)
          this.closeTasksDialog()
        })
        .catch((err) => {
          this.tasksLoading = false
          console.log(err)
        })
    },
    updateTaskApi () {
      this.tasksLoading = true
      this.editedTaskItem.counter_id = this.selectedCounterId
      axios.put(`/api/counters_tasks/`, this.editedTaskItem)
        .then((response) => {
          this.tasksLoading = false
          Object.assign(this.editedTaskItem[this.editedCounterTaskIndex], response.data)
          this.closeTasksDialog()
        })
        .catch((err) => {
          this.tasksLoading = false
          console.log(err)
        })
    },
    deleteCounterTask (item) {
      const id = item.counter_task_id
      this.tasksLoading = true
      axios.delete(`/api/counters_tasks/${id}`)
        .then((response) => {
          this.tasksLoading = false
          const index = this.editedTaskItem.indexOf(item)
          this.editedTaskItem.splice(index, 1)
        })
        .catch((err) => {
          this.tasksLoading = false
          console.log(err)
        })
    },
    startCounterTaskApi (item) {
      const id = item.counter_task_id
      axios.post(`/api/counters_tasks/${id}/start_scheduler/`)
        .then((response) => {
          const index = this.counterTasks.indexOf(item)
          Object.assign(this.counterTasks[index], response.data)
          this.editedTaskItem = Object.assign({}, response.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    stopCounterTaskApi (item) {
      const id = item.counter_task_id
      this.editedTaskItem.enabled = false
      this.editedTaskItem.counter_id = this.selectedCounterId
      axios.put(`/api/counters_tasks/${id}/`, this.editedTaskItem)
        .then((response) => {
          const index = this.counterTasks.indexOf(item)
          Object.assign(this.counterTasks[index], response.data)
          this.editedTaskItem = Object.assign({}, response.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    editCounterTask (item) {
      this.editedCounterTaskIndex = this.editedTaskItem.indexOf(item)
      this.editedTaskItem = Object.assign({}, item)
      this.taskDialog = true
    },
    saveCounterTask () {
      if (this.editedIndex > -1) {
        this.updateTaskApi()
      } else {
        this.addTaskApi()
      }
    },
    closeTasksDialog () {
      this.taskDialog = false
    },
    stopTasks (item) {
      this.stopCounterTaskApi(item)
    },
    startTasks (item) {
      this.startCounterTaskApi(item)
    },
    resetState () {
      this.loaded = false
    },
    requestAccumulatedData () {
      this.resetState()
      if (this.parameter_id) {
        axios.get(`/api/counters_accumulated_data/?point_id=${this.point_id}`)
          .then(response => {
            this.countersAccumulatedData = response.data
            this.loaded = true
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    requestData () {
      this.resetState()
      this.requestAccumulatedData()
      if (this.parameter_id) {
        axios.get(`/api/counters_profile_data/?point_id=${this.point_id}&parameter_id=${this.parameter_id}&interval=${this.reportInterval}`)
          .then(response => {
            this.countersData = response.data.map(data => data.value)
            this.countersData2 = response.data
            this.labels = response.data.map(data => data.label)
            this.loaded = true
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spa/points/PointCountersData.vue